import './src/App.css'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./src/styles/edge-hide.css";

import React from "react";
import { AuthProvider } from "./src/context/AuthContext";
import { FavouriteProvider } from "./src/context/FavouriteContext";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

export const wrapRootElement = ({ element }) => (
	<GoogleReCaptchaProvider
		reCaptchaKey={process.env.GATSBY_RECAPTCHA_SITE_KEY}
		scriptProps={{ async: true, defer: true, appendTo: "head" }}
	> <AuthProvider> <FavouriteProvider>{element}</FavouriteProvider></AuthProvider>
	</GoogleReCaptchaProvider>);
